/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import percentageLoader from "@/components/percentage-loader-f-file";
import root from '@/_helpers/roots';
import toast from '@/services/toast';
let eventGalleriesApiUrl = root.eventGalleriesApiUrl.link;

export default {
  name: 'event-gallery-screen',
  components: {
    percentageLoader
  },
  props: [],
  data () {
    return {
      submitted:false,
      title:'',
      banner:null,
      bannerName:'',
      bannerImages:[],
      uploadProgress:0
    }
  },
  computed: {
  },
  mounted(){
    this.getPhotosOfGalleriesMethod();
  },
  methods: {
    getPhotosOfGalleriesMethod(){
      this.$store.dispatch('getEventInfoByIdAction', {id:this.$route.params.eventId}).then((res) => {
        this.title = res.data.data.title
        this.bannerImages = res.data.data.events_gallery
      })
    },
    deleteImageFromGalleriesMethod(id){
      this.$store.dispatch('removePhotoInGalleriesAction', {id:id}).then((res) => {
        toast.success(res.data.msg || "Request has been successfully submitted");   
        this.getPhotosOfGalleriesMethod();
      })
    },
    // GET THE IMAGE WIDTH AND HEIGHT USING fileReader() API.
    readImageFile(file) {
      var __self = this
      var reader = new FileReader(); // CREATE AN NEW INSTANCE.
      reader.onload = function (e) {
        var img = new Image();
        img.src = e.target.result;
        img.onload = function () {
          var w = this.width;
          var h = this.height;
          if (w > 1200 && h > 150) {
            __self.uploadImgSize = true
          } else {
            __self.uploadImgSize = false
          }
        }
      };
      reader.readAsDataURL(file);
    },
    clearUploadedBannerMethod(){
      let field = document.getElementById('bannerFile');
      field.value = null
      this.banner = null
      this.bannerName = ''
      this.$validator.reset()
    },
    handleBannerUploadMethod(event) {
      if(event.target.files && event.target.files.length > 0) {
        this.banner = event.target.files[0];
        const files = this.$refs.bannerFile.files[0];
        this.bannerName = files.name
        this.submitted = true;
        var formData = new FormData();
        formData.append('event', this.$route.params.eventId);
        formData.append('image', this.banner);     
        axios.post(eventGalleriesApiUrl, formData, {
          onUploadProgress: progressEvent => {
            this.uploadProgress = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            );
          },
        }).then((res) => {  
              this.submitted = false;
              this.getPhotosOfGalleriesMethod();
              this.clearUploadedBannerMethod();
              toast.success(res.data.msg || "Request has been successfully submitted");
              this.uploadProgress = 0
          }).catch((err) => {
              this.submitted = false;
              this.uploadProgress = 0
              toast.error(err.data.user_msg || err.data.msg);
          })
      }
    },
  },
  watch:{
  }
}